import { Component } from "@angular/core";

@Component({
  selector: "service-publish-history",
  templateUrl: "./service-publish-history.component.html",
})
export class ServicePublishHistoryComponent {

}
